<template></template>

<script>
export default {
  name: "cartComponent",
  props: {
    isDropDown: { type: Boolean, default: false },
  },
  components: {},
  data() {
    return {};
  },
  mounted() {
    EventBus.$on("update-cart-item", async (data) => {
      this.updateItem(
        data.idCartItem,
        data.cantidad,
        data.fechaEntrega,
        data.idProductoCliente,
        data.idPedido,
        data.origenCreacion
      );
    });
    EventBus.$on("add-to-cart", async (data) => {
      this.addToCart(
        data.idProductoCliente,
        data.cantidad,
        data.fechaEntrega,
        data.material,
        data.origenCreacion
      );
    });
    EventBus.$on("remove-from-cart", async (itemId) => {
      this.removeFromCart(itemId);
    });
    EventBus.$on("add-to-cart-list", (itemList) => {
      this.addToCartList(itemList);
    });
  },
  beforeDestroy() {
    //do something before destroying vue instance
    EventBus.$off("update-cart-item");
    EventBus.$off("add-to-cart");
    EventBus.$off("remove-from-cart");
    EventBus.$off("add-to-cart-list");
  },
  methods: {
    addToCart(
      idProductoCliente,
      cantidad,
      fechaEntrega,
      material,
      origenCreacion
    ) {
      console.log(
        "Guardar idProductoCliente: " +
        idProductoCliente +
        " cantidad: " +
        cantidad +
        " fecha: " +
        fechaEntrega +
        " material: " +
        material
      );
      var params = {
        idProductoCliente:
          idProductoCliente != null
            ? parseInt(idProductoCliente)
            : idProductoCliente,
        cantidad: parseInt(cantidad),
        fechaEntrega: fechaEntrega,
        origenCreacion: origenCreacion,
        material: material,
        usuario: this.$store.state.user.idUsuario,
      };
      this.$http.post(route("Cart/addToCart"), params).then(
        (response) => {
          console.log(
            "response de guardado -->  : " + JSON.stringify(response)
          );
          if (response.body.code === 200) {
            //console.log("response de guardado -->  : "+ JSON.stringify(response));
            this.notifyMessage("success", this.$t("app.cart.promps.addSucces"));
            console.log("antes de loaditems en addToCart");
            this.loadItems();
          } else {
            let code = response.body.code;

            if (code === 510) {
              this.notifyMessage(
                "danger",
                this.$t("app.cart.promps.addFail") + material
              );
            }

            if (code === 520) {
              this.notifyMessage(
                "danger",
                this.$t("app.cart.promps.partNumber_withoutminimum") + material
              );
            }

            if (code === 530) {
              this.notifyMessage("danger", response.body.message);
            }

          }
        },
        (error) => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );

    },
    async removeFromCart(idCartItem) {
      var params = {
        idCartItem: idCartItem,
      };
      await this.$http.post(route("Cart/removeFromCart"), params).then(
        (response) => {
          if (response.body.code === 200) {
            this.notifyMessage(
              "success",
              this.$t("app.cart.promps.removeSucces")
            );
            this.loadItems();
          } else {
            this.notifyMessage("danger", this.$t("app.cart.promps.removeFail"));
          }
        },
        (error) => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );

    },
    async updateItem(
      itemId,
      cantidad,
      fechaEntrega,
      idProductoCliente,
      idPedido
    ) {
      console.log(
        "actualizar item id: " +
        itemId +
        " cantidad: " +
        cantidad +
        " fecha: " +
        fechaEntrega +
        " idProductoCliente: " +
        idProductoCliente +
        " idPedido: " +
        idPedido
      );
      var paramsUpdate = {
        idCartItem: parseInt(itemId),
        cantidad: parseInt(cantidad),
        fechaEntrega: fechaEntrega,
        idProductoCliente: parseInt(idProductoCliente),
        idPedido: parseInt(idPedido),
      };
      await this.$http.put(route("Cart/updateItemCart"), paramsUpdate).then(
        (response) => {
          if (response.body.code === 200) {
            //this.notifyMessage("success", this.$t("app.cart.promps.addSucces"));
            this.loadItems();
          } else {
            console.log(response.body);
            this.notifyMessage("danger", this.$t("app.cart.promps.addFail"));
          }
        },
        (error) => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );
    },
    addToCartList(cartList) {
      console.log("Guardar cartList");

      this.$http.post(route("Cart/addToCartList"), cartList).then(
        (response) => {
          if (response.body.code === 200) {
            console.log(
              "response de guardado -->  : " + JSON.stringify(response)
            );
            this.notifyMessage("success", this.$t("app.cart.promps.addSucces"));
            this.loadItems();

          } else {
            let code = response.body.code;

            console.log(
              "response de guardado sin exito -->  : " + JSON.stringify(response)
            );

            //if (code === 510) {
            response.body.sumary.forEach((c) => {

              if (c.id === 510) {

                this.notifyMessage(
                  "danger",
                  this.$t("app.cart.promps.addFail") + c.message
                );

              }

              if (c.id === 520) {

                this.notifyMessage(
                  "danger",
                  this.$t("app.cart.promps.partNumber_withoutminimum") + c.message
                );

              }


              if (c.id === 530) {

                this.notifyMessage("danger", c.message);

              }


              if (c.id === 540) {

                this.notifyMessage("danger", c.message);

              }


            }
            );

            this.loadItems();
          }
        },
        (error) => {
          console.error(error);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      );

    },
    loadItems() {
      console.log("loadItems de component");
      EventBus.$emit("load-cart-items");
    },
  },
};
</script>

<style scoped></style>
